﻿<template>

    <template v-if="!sucessfullyRegistered">
        <div class="lg-head">
            <span class="lg-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" /><path d="M20 8v6M23 11h-6" /></svg>
            </span>
            <h2 class="lg-heading">Register</h2>
            <p class="lg-intro">Please complete the registration form to register for {{getLoginTitle()}}. You will receive an email containing your username and password.</p>
        </div>

        <div class="mb-form-grid is-two">
            <div class="mb-field">
                <label for="register_name">Name *</label>
                <input type="text" id="register_name" name="name" autocomplete="name" class="mb-input" v-model="Register_Request.name" />
            </div>
            <div class="mb-field">
                <label for="register_agency_name">Agency name *</label>
                <input type="text" id="register_agency_name" name="agency_name" autocomplete="organization" class="mb-input" v-model="Register_Request.agency_name" />
            </div>
            <div class="mb-field">
                <label for="register_agency_email">Agency email address *</label>
                <input type="email" id="register_agency_email" name="agency_email_address" autocomplete="email" spellcheck="false" class="mb-input" v-model="Register_Request.agency_email" />
            </div>
            <div class="mb-field">
                <label for="register_agency_phone">Agency phone number *</label>
                <input type="tel" id="register_agency_phone" name="agency_phone_number" autocomplete="tel" class="mb-input" v-model="Register_Request.agency_phone_number" />
            </div>
            <div class="mb-field is-full">
                <label for="register_agency_address">Agency address *</label>
                <input type="text" id="register_agency_address" name="agency_address" autocomplete="address-line1" class="mb-input" v-model="Register_Request.agency_address_line_1" />
            </div>
            <div class="mb-field is-full">
                <label for="register_agency_address_2" class="sr-only">Agency address line 2</label>
                <input type="text" id="register_agency_address_2" name="agency_address_2" autocomplete="address-line2" class="mb-input" placeholder="Address line 2 (optional)" v-model="Register_Request.agency_address_line_2" />
            </div>
            <div class="mb-field">
                <label for="register_iata">IATA</label>
                <input type="text" id="register_iata" name="iata" class="mb-input" v-model="Register_Request.iata" />
            </div>
            <div class="mb-field">
                <label for="register_abn">ABN</label>
                <input type="text" id="register_abn" name="abn" class="mb-input" v-model="Register_Request.abn" />
            </div>
        </div>

        <!-- <vue-honeypot ref="honeypot" /> -->

        <form id="registerAgentForm" action="" class="lg-captcha">
            <Turnstile @verified="onTurnstileVerified" />
        </form>

        <login_alert :message="error_message" @dismiss="error_message = ''"></login_alert>

        <button type="button" class="button button-pink-book full lg-submit" :disabled="isRegistering" @click="Register()">
            <svg v-if="isRegistering" class="mb-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
            {{ isRegistering ? 'Submitting…' : 'Submit registration' }}
        </button>

        <div class="lg-links">
            <button type="button" class="lg-link" @click="Login()">Back to login</button>
            <button type="button" class="lg-link" @click="Forgot_Password()">Forgot password?</button>
        </div>

        <p class="lg-contact">{{getContactInfo()}}</p>
    </template>

    <div v-else class="lg-done">
        <span class="lg-icon is-success" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
        </span>
        <h2 class="lg-heading">Registration successful</h2>
        <p class="lg-intro">Thank you for registering! You will receive an email shortly.</p>
        <router-link to="/login" class="button button-pink-book full lg-submit">Back to login</router-link>
    </div>

</template>

<script lang="ts" src="./register_screen.ts"></script>
